export default __webpack_public_path__ + "static/media/save_icon_grey.cdd1e943.svg";